export default {
  allSites(state) {
    return state.sites;
  },
  selectedSite(state) {
    return state.site;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/sites/getters.js